import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-primary-100">
      <div className="w-full max-w-md p-4">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-primary-600">PianoProjects</h1>
          <p className="text-gray-600 mt-2">AI-Native Engineering Platform</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
